import CourseSettingsService from 'services/course-handler-services/course-settings-service';
import { MemoryStorageService } from 'services/data-handler-services/web-storage-service';
import utils from 'lib/utils';
import EF from 'ef/ef';
import _ from 'lodash';

const MenuService = {
  autoPlay: function () {
    const menu = CourseSettingsService.get('menu');

    const options = Object.assign({}, menu.autoplay);
    if (EF.enrollment.get('demoMode') && menu.auto_play_demo) {
      Object.assign(options, menu.auto_play_demo);
    }

    const lastInProgress = _.find(options.modules, function (moduleKey) {
      const module = EF.modules.getModuleByKey(moduleKey);
      const plays = MemoryStorageService.getItem(`${moduleKey}:plays`) || 0;
      return (
        module &&
        !module.get('locked') &&
        module.get('completed') === false &&
        (options.limit === undefined || plays < options.limit)
      );
    });

    if (lastInProgress) {
      const plays = (MemoryStorageService.getItem(`${lastInProgress}:plays`) || 0) + 1;
      MemoryStorageService.setItem(`${lastInProgress}:plays`, plays);
      utils.redirectToModule(EF.modules.getModuleByKey(lastInProgress));
    }
  },
  getUnlockDay() {
    const startDateCustomization = CourseSettingsService.get('start_date');
    if (startDateCustomization) {
      return utils.daysFromToday(startDateCustomization);
    }
  },
};
export default MenuService;
